import i18n from 'i18next';

import { CARD_WIDTH } from 'constants/widths';

import { getStackStyle } from '../../CardsView/utils/utils';

interface MultiSelectDragPreviewProps {
  count: number;
}

/**
 * Native drag preview rendered via `setCustomNativeDragPreview` in
 * `DraggableCardPragmatic`. Replaces the per-card browser ghost with a
 * stacked-cards visual labelled "{count} selected" — mirrors the dnd-kit
 * `DraggableOverlay` behaviour from the legacy `CardsView`.
 *
 * Rendered into a detached React root, so it can NOT rely on app-level
 * providers (Recoil / MUI ThemeProvider / I18nextProvider). Uses `i18n.t`
 * directly and inline styles to stay self-contained.
 */
export default function MultiSelectDragPreview({
  count
}: MultiSelectDragPreviewProps) {
  return (
    <div
      style={{
        boxSizing: 'border-box',
        padding: '4px 4px 2px 4px',
        borderRadius: 0,
        border: '1px solid rgba(0, 0, 0, 0.12)',
        flexShrink: 0,
        overflow: 'hidden',
        width: `${CARD_WIDTH}px`,
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        boxShadow: getStackStyle(count),
        fontFamily: 'inherit',
        fontSize: '14px',
        cursor: 'grabbing'
      }}
    >
      {`${count} ${i18n.t('activityPlanning.selected')}`}
    </div>
  );
}
